exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".form-group-textfield-suggested{width:auto!important;height:40px}.form-group-textfield-suggested .bp-textfield{height:1.3em}.form-group-textfield-suggested .bp-textfield__input{margin-top:.3em}.form-group-textfield-suggested .bp-textfield__label{color:#fff!important;font-weight:200!important}.form-group-textfield-suggested .bp-textfield__icon{bottom:0!important;color:#777}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested.scss
 ** module id = 244
 ** module chunks = 0
 **/